import service from '@/utils/axios';

export function getArticleList(id, pageObj) {
    return service({
        url: '/admin/api/v1/dxsf/official/getArticleList',
        params: {column_id: id, ...pageObj}
    })
}
export function getArticle(id) {
    return service({
        url: '/admin/api/v1/dxsf/official/getArticle',
        params: {id}
    })
}


// WEBPACK FOOTER //
// ./src/api/news.js